var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current)?_c('div',{staticClass:"page-sidebar-nav hide-for-print"},[_c(_vm.current,{tag:"component",attrs:{"countriesRegime":this.countriesRegime}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f00b2da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navigation/PageSidebarNavigation/Nav.vue
// module id = 288
// module chunks = 0